type RuntimeLocation = Pick<Location, 'protocol' | 'host' | 'hostname'>;

function getLocationFromWindow(): RuntimeLocation | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const windowLocation = window.location;
  if (!windowLocation?.protocol) {
    return undefined;
  }

  return windowLocation;
}

function getLocationFromSelfGlobalScope(): RuntimeLocation | undefined {
  if (typeof self === 'undefined') {
    return undefined;
  }

  // Window and ServiceWorkerGlobalScope declare `location`; a plain EventTarget
  // (e.g. a stubbed `self` in vitest) does not — treat that as "no location".
  const selfExposesLocation = 'location' in self;
  if (!selfExposesLocation) {
    return undefined;
  }

  const selfLocation = self.location;
  if (!selfLocation?.protocol) {
    return undefined;
  }

  return selfLocation;
}

/**
 * Location of the current JS runtime global.
 *
 * Prefers `window` (browser tab). Falls back to `self.location` only when `self`
 * is a global scope that exposes `location` (e.g. service worker), not a plain
 * EventTarget used as a test spy.
 */
export function getRuntimeLocation(): RuntimeLocation | undefined {
  return getLocationFromWindow() ?? getLocationFromSelfGlobalScope();
}
